import React, { useEffect, useMemo, useState } from 'react';
import {
  Wrapper,
  Container,
  Back,
  Line,
  Title,
  BreadCrumb,
  InfoContainer,
  PaymentContainer,
  ButtonContainer,
  Button,
} from './styles';

import { FiFileText } from 'react-icons/fi';
import { BiCalendar } from 'react-icons/bi';
import moment from 'moment';
import GoBackPage from '../../components/GoBackPage';
import { useHistory, useLocation } from 'react-router-dom';
import { page } from '../../store/auth/actions';
import { useDispatch } from 'react-redux';

import ModalContracts from '../../components/Modal/Contracts';
import formatPrice from '../../services/utils/formatPrice';
import { navigationUrl, negotiation } from '../../store/analytic/actions';
import { getContractsFromDealOrDebt } from '../../utils/getContractsToShow';

type ProposalProps = {
  contract: GQL.IDebt;
  proposal: GQL.IProposalDetails;
  agreement: GQL.IDeal;
};

const AbstractProposal: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation<ProposalProps>();
  const contract: GQL.IDebt = location.state && location.state.contract;
  const proposal: GQL.IProposalDetails =
    location.state && location.state.proposal;
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const contractsToShow = useMemo(() => getContractsFromDealOrDebt(contract), [
    contract,
  ]);

  useEffect(() => {
    if (contract && proposal) {
      dispatch(page('contrato'));
      dispatch(
        navigationUrl.request({
          action: '/confirmarProposta',
          creditor: contract.creditorName,
          dealValue:
            proposal.entryValue + (proposal.plan - 1) * proposal.portionValue,
          dealType: contract.proposalType ? contract.proposalType : 0,
          delay: contract.longerDelay,
          plan: proposal.plan,
        })
      );
    } else {
      history.push('/contrato');
    }
  }, [dispatch, contract, proposal, history]);

  const handlerOptions = (): void => {
    setLoading(true);
    dispatch(
      negotiation.request({
        creditor: contract.creditorName,
        dealValue:
          proposal.entryValue + (proposal.plan - 1) * proposal.portionValue,
        dealType: contract.proposalType || 6,
        delay: contract.longerDelay,
        plan: proposal.plan,
        databaseId: contract.databaseId,
        // pegar essas informações do dealState[0]
        dealId: 0,
      })
    );
    const detail = {
      portion: `${proposal.plan - 1} parcelas de R$ ${formatPrice(
        proposal.portionValue
      )}`,
      value: formatPrice(proposal.entryValue),
      date: moment(contract.proposalDueDate).format('DD/MM/YYYY'),
    };
    setLoading(false);
    history.push({
      pathname: '/opcoes',
      state: { contractDebt: contract, proposal, type: 'debito', detail },
    });
  };

  const handlerContracts = (): void => {
    setOpen(true);
  };

  const handlerClose = (): void => {
    setOpen(false);
  };

  return (
    <Wrapper>
      <Container>
        <Line>
          <Title>Resumo</Title>
          <BreadCrumb>
            <span id='link' onClick={() => history.push('/contrato')}>
              Débitos e Acordos
            </span>
            <span id='bar'> / </span>
            <span id='link' onClick={() => history.goBack()}>
              Meu Débito
            </span>
            <span id='bar'> / </span>
            <span>Resumo</span>
          </BreadCrumb>
          <Back>
            <GoBackPage text='Resumo' />
          </Back>
        </Line>

        <InfoContainer>
          <h2>
            Valor da dívida: R$ {formatPrice(contract && contract.updatedValue)}
          </h2>
          <p>{contract && contract.creditorName}</p>
          <div className='options'>
            <FiFileText className='space-right' />
            {contract && contract.contracts.length > 1
              ? 'Múltiplos contratos: '
              : 'Contrato: '}
            {contract && contract.contracts.length === 1 && (
              <span>{contract && contract.contracts[0]}</span>
            )}
            {contract && contract.contracts.length > 1 && (
              <a onClick={handlerContracts}>Clique para exibir</a>
            )}
          </div>
          {contract && contract.proposalDueDate && (
            <div className='options'>
              <BiCalendar className='space-right' />
              Vencimento da entrada:{' '}
              <span className='date'>
                {moment(contract && contract.proposalDueDate).format(
                  'DD/MM/YYYY'
                )}
              </span>
            </div>
          )}
        </InfoContainer>

        <PaymentContainer>
          <h2>Opção de pagamento selecionada</h2>
          <div className='container'>
            <div className='quantity'>{proposal && proposal.plan}x</div>
            <div className='info'>
              <p>
                {proposal && proposal.portionValue > 0
                  ? 'Entrada de'
                  : 'À Vista'}
              </p>
              <h3>R$ {formatPrice(proposal && proposal.entryValue)}</h3>
              {proposal && proposal.portionValue > 0 && (
                <p className='strong'>
                  + {proposal && proposal.plan - 1} parcelas de R${' '}
                  {proposal && formatPrice(proposal.portionValue)}{' '}
                </p>
              )}
            </div>
          </div>
        </PaymentContainer>
        <ButtonContainer>
          <Button color='secondary' onClick={() => history.goBack()}>
            Voltar
          </Button>
          <span className='desktop'>
            <Button color='primary' onClick={handlerOptions} disabled={loading}>
              Confirmar e pagar
            </Button>
          </span>
          <span className='mobile'>
            <Button color='primary' onClick={handlerOptions} disabled={loading}>
              Confirmar{' '}
            </Button>
          </span>
        </ButtonContainer>
      </Container>

      {open && (
        <ModalContracts
          handlerClose={handlerClose}
          contracts={contractsToShow}
        />
      )}
    </Wrapper>
  );
};

export default AbstractProposal;
